import React, { useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as ErpAgentActions from '../../../actions/erpAgentActions';

import * as classes from './DeleteFsmAgentModal.module.css';

const DeleteFsmAgentModal = ({
    activeNavCompany,
    integration,
    deleteErpAgent,
    setDeleteAgentModalOpen,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteAgent = async () => {
        const agentId = integration.id;

        setIsLoading(true);
        let isDeleted = await deleteErpAgent(activeNavCompany.id, agentId);
        setIsLoading(false);

        if (isDeleted) setDeleteAgentModalOpen(false);
    };

    return (
        <BobModal
            title={'Delete Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setDeleteAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Integration Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {integration.name}
                    </div>
                </div>
                <div className={classes.InfoPanel}>
                    <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                    <span className={classes.InfoText}>
                        If you delete this FSM Integration configuration you will lose all inventory items and links created in Architect associated with this FSM Integration
                    </span>
                </div>
                <div className={classes.ConfirmationPanel}>
                    Are you sure you want to delete?
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setDeleteAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'No'}
                    />
                    <BobConfirmButton
                        disabled={isLoading}
                        onClick={() => handleDeleteAgent()}
                        className={isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Yes'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteFsmAgentModal);
